<template>
  <div>
    <div class="container">
      <div class="row mb-5">
        <div class="col-12 col-sm-6 mx-auto">
          <Card>
            <div
              v-if="alert"
              class="alert alert-danger"
            >
              Domain is not valid.
            </div>
            <div class="form-group url-form">
              <label for="urlInput">Enter your Domain</label>
              <input
                id="urlInput"
                v-model="domain"
                type="text"
                class="form-control"
                placeholder="Your URL here…"
                @keyup.enter="nextStep()"
              >
            </div>
            <button
              class="btn btn-lg btn-gradient-primary btn-oval w-100 mt-1 pt-2 pb-2"
              @click="nextStep()"
            >
              START NOW
            </button>
          </Card>
        </div>
      </div>
    </div>

    <about-section />
    <Faq />
  </div>
</template>
<script>

import { mapActions } from 'vuex'
import AboutSection from '@/components/AboutSection';
import Faq from '@/components/Faq';

export default {

  head: {
    title: {
      inner: 'SEO Analyzer: Free Analysis Tool & Audit Report'
    },
    meta: [
      { name: 'description', content: "Can't understand why your competitors rank above you, look no further and instantly check how your website stacks against your competitors to outrank them", id: 'desc' }
    ],
    link: [
      { rel: 'canonical', href: 'https://www.seo-browser.com', id: 'canonical' },
    ]
  },

  components: {
    AboutSection,
    Faq
  },

  data() {
    return {
      domain: 'https://',
      alert: false
    }
  },

  methods: {
    ...mapActions('app', ['updateURL']),

    nextStep() {
      this.alert = false;

      const { domain } = this;

      if(!this.IsDomainValid(domain)) {
        this.alert = true;
        return;
      }
      // TODO: Validate domain
      window.location = `/analyze/${this.formatUrl(domain)}/keywords`;
    }
  }
}
</script>

<style scoped lang="scss">
.main-image {
  max-height: 15rem;
  width: 100%;
  margin: 0 auto;
  display: block;
}
.form-group {
  label {
    color: #000000;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }
  input {
    border: 1px solid #dbdbdb;
    border-radius: 2px;

    &::placeholder {
      color: #000000;
      font-size: 16px;
      font-family: Montserrat, sans-serif;
      font-weight: 300;
    }
  }
  button {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    font-size: 16px;
  }
}
</style>
